<template>
  <div class="top-ten">
    <el-row type="flex" class="top-ten_title body1 row-bg" v-if="title">
      <el-col :span="18">{{ title }}</el-col>
    </el-row>
    <el-row type="flex" class="top-ten_col_headers" :gutter="6" v-if="colHeaders">
      <el-col
        class="subtitle2"
        :class="{ 'justify-end': idx > 0 }"
        :span="idx === 0 ? 16 : 8"
        v-for="(col, idx) in colHeaders"
        :key="idx"
        >{{ col }}</el-col
      >
    </el-row>
    <div class="top-ten_list" v-if="entries.length > 0">
      <el-row
        type="flex"
        :gutter="6"
        class="subtitle2 row-bg cursor-pointer"
        :class="{ 'row-selected': rowSelected === row }"
        v-for="(row, idx) in pageEntries"
        :key="idx"
        @click.native="rowClick(row)"
      >
        <el-col
          :class="{ 'justify-end': idx > 0 }"
          :span="idx === 0 ? 16 : 8"
          v-for="(key, idx) in fields"
          :key="idx"
          >{{ row[key] }}</el-col
        >
      </el-row>
    </div>
    <el-row v-if="entries.length > 0">
      <el-col :span="8">
        <span class="subtitle1"> {{ pageSummary }} </span>
      </el-col>
      <el-col :span="16">
        <el-pagination
          class="float-right"
          small
          layout="prev, pager, next"
          :hide-on-single-page="true"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="entries.length"
          @current-change="pageChange"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <div class="empty_text" v-else>No Data</div>
  </div>
</template>
<script>
export default {
  name: 'TopTenCard',
  props: {
    title: String,
    startingPageNum: { type: Number, default: 1 },
    pageSize: { type: Number, default: 25 },
    colHeaders: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    entries: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    }
  },
  computed: {
    pageSummary () {
      let startRecordCount = (this.currentPage - 1) * this.pageSize
      let endRecordCount = this.pageSize * this.currentPage
      if (this.pageEntries.length < this.pageSize) {
        endRecordCount = this.entries.length
      }
      let recordCount = `${startRecordCount + 1}-${endRecordCount}`
      return `${recordCount} of ${this.entries.length}`
    },
    pageEntries () {
      return this.entries.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    fields () {
      let properties = []
      if (!_.isEmpty(this.entries)) {
        for (let key in this.entries[0]) {
          properties.push(key)
        }
      }
      if (properties[0] === 'count') {
        return properties.reverse()
      }
      return properties
    }
  },
  data () {
    return {
      currentPage: this.startingPageNo,
      rowSelected: {}
    }
  },
  methods: {
    getColSpan (colIndex) {
      if (this.fields.length === 2) {
        if (colIndex === 0) {
          return 16
        }
        return 8
      }
      return 24 / this.fields.length
    },
    rowClick (row) {
      if (this.rowSelected === row) {
        this.rowSelected = {}
      } else {
        this.rowSelected = row
      }
      this.$emit('top-ten-click', row)
    },
    pageChange () {
      let toptenEl = this.$el.querySelectorAll('.top-ten_list')
      toptenEl[0].scrollTop = 0
    },
    resetPageNum () {
      this.currentPage = 1
    }
  },
  mounted () {}
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.top-ten {
  height: inherit;

  .top-ten_title {
    height: 40px;
  }

  .top-ten_list {
    height: 95%;
    overflow: scroll;
    padding-right: 10px;

    >>> .el-col {
      overflow-wrap: break-word;
    }
  }
}

.row-bg {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-bottom: 0.5px;
  border: none;
  border-bottom: 1px solid var(--border-color);

  .el-col:first-child {
    word-break: break-all;
  }
}

.row-selected {
  background: var(--denim-50);
}

.top-ten_col_headers {
  border-bottom: 1px solid var(--border-color);
  color: var(--text-color-info);
  padding-right: 10px;
}

.empty_text {
  color: var(--text-color-info);
  text-align: center;
  vertical-align: middle;
  line-height: 100px;
}

.justify-end {
  text-align: right;
}

.subtitle1 {
  line-height: 26px;
  vertical-align: bottom;
}

>>> .el-pagination {
  .btn-prev,
  .btn-next {
    padding-left: 0px;
    padding-right: 0px;
  }
}

>>> .el-pager {
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/card/TopTenCard.vue